var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import * as R from 'ramda';
import { connect } from 'react-redux';
import * as A from '../../store/forms/actions';
import * as S from '../../store/forms/selectors';
import * as PA from '../../store/processes/actions';
import { selectProcessesBusy, selectProcessesError } from '../../store';
import { ExtraActionType } from '../../models/form.types';
import { XbpmActionType, XbpmFieldType } from '../../models/xbpm.enums';
import { asyncTap } from '../../services/utils/_.utils';
// form selector
var selectFormDef = function (state, _a) {
    var params = _a.params;
    switch (params.$kind) {
        case 'task': {
            var processInstanceId = params.processInstanceId, taskDefinitionKey = params.taskDefinitionKey, modalFormCode = params.modalFormCode;
            return S.selectForm(processInstanceId, taskDefinitionKey, modalFormCode)(state);
        }
        case 'free': {
            var applicationGroup = params.applicationGroup, applicationCode = params.applicationCode, applicationVersion = params.applicationVersion, freeFormCode = params.freeFormCode;
            return S.selectFreeForm(applicationGroup, applicationCode, applicationVersion, freeFormCode)(state);
        }
    }
    return null;
};
//
var pickBusyProps = R.pick(['isLoading', 'isSubmitting']);
// redux store props
var mapStateToProps = function (state, props) { return ({
    def: selectFormDef(state, props),
    isLoading: S.selectFormsLoading(state) || selectProcessesBusy(state),
    isSubmitting: S.selectFormsSubmitting(state),
    error: S.selectFormsError(state) || selectProcessesError(state) || null,
    internalStatus: S.selectFormsInternalStatus(state),
}); };
var mapDispatchToProps = function (dispatch) { return ({ dispatch: dispatch }); };
var FormBaseComponent = /** @class */ (function (_super) {
    __extends(FormBaseComponent, _super);
    function FormBaseComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.matchParams = function (cb) {
            var params = _this.props.params;
            if (params.$kind === 'free' && cb.free) {
                cb.free(params);
            }
            else if (params.$kind === 'task' && cb.task) {
                cb.task(params);
            }
            else if (params.$kind === 'act' && cb.act) {
                cb.act(params);
            }
            else if (params.$kind === 'process' && cb.procByKey) {
                cb.procByKey(params);
            }
            else if (params.$kind === 'application' && cb.procByApp) {
                cb.procByApp(params);
            }
            else if (cb._default) {
                cb._default(params);
            }
        };
        _this.loadForm = function () {
            var dispatch = _this.props.dispatch;
            _this.matchParams({
                task: function (params) { return dispatch(A.loadAction(params)); },
                free: function (params) { return dispatch(A.loadFreeAction(params)); },
                act: function (params) { return dispatch(A.loadActAction(params)); },
                procByKey: function (params) { return dispatch(PA.startProcessByKeyAction(params)); },
                procByApp: function (params) { return dispatch(PA.startProcessByAppAction(params)); },
                _default: function () { return console.error('Not enough params to load form!'); },
            });
        };
        _this.onBusy = function () { return _this.props.onBusy(pickBusyProps(_this.props)); };
        _this.onError = function () { return _this.props.onError(_this.props.error); };
        _this.shouldFormLoad = function (prevProps) {
            return !R.eqProps('params', _this.props, prevProps);
        };
        _this.shouldShowError = function (prevProps) {
            return !R.eqProps('error', _this.props, prevProps);
        };
        _this.shouldShowBusy = function (prevProps) {
            return !R.eqBy(pickBusyProps, _this.props, prevProps);
        };
        _this.shouldUpdateInternalStatus = function (prevProps) {
            return !R.eqBy(R.prop('internalStatus'), _this.props, prevProps);
        };
        _this.shouldCleanForm = function () {
            return !_this.props.def && !!_this.props.formHandler.context.formDefinition;
        };
        _this.componentDidUpdate = R.pipe(R.when(_this.shouldUpdateInternalStatus, asyncTap(function () {
            var eventsHandler = _this.props.formHandler.eventsHandler;
            switch (_this.props.internalStatus) {
                case 'err':
                    return eventsHandler.onApiErr();
                case 'ok':
                    return eventsHandler.onApiOk();
            }
        })), R.when(_this.shouldShowError, asyncTap(_this.onError)), R.when(_this.shouldShowBusy, asyncTap(_this.onBusy, 100)), R.when(_this.shouldFormLoad, asyncTap(function () { return _this.loadForm(); })), R.when(_this.shouldCleanForm, function () { return _this.props.formHandler.clean(); }));
        _this.handleFormActions = function (event) {
            var _a = _this.props, dispatch = _a.dispatch, formHandler = _a.formHandler;
            var context = formHandler.context;
            var def = context.formDefinition;
            var fieldId = R.pathOr(null, ['target', 'id'], event);
            var fieldValue = R.path(['target', 'value'], event);
            if (!!fieldId) {
                def = _this.handleFormElement(def, fieldId, fieldValue);
            }
            var initiator = event.target;
            switch (event.type) {
                case XbpmActionType.SAVE:
                    _this.handleFormActionIfBlockValid(event.target, function () {
                        _this.matchParams({
                            free: function (params) { return dispatch(A.saveFreeAction(__assign(__assign({}, params), { initiator: initiator, def: def }))); },
                            task: function (params) { return dispatch(A.saveAction(__assign(__assign({}, params), { initiator: initiator, def: def }))); },
                        });
                    });
                    return;
                case XbpmActionType.NEXT: {
                    _this.handleFormActionIfBlockValid(event.target, function () {
                        _this.matchParams({
                            task: function (params) { return dispatch(A.nextAction(__assign(__assign({}, params), { initiator: initiator, def: def }))); },
                        });
                    });
                    return;
                }
                case XbpmActionType.UPDATE_BLOCK: {
                    _this.handleFormActionIfBlockValid(event.target, function () {
                        _this.matchParams({
                            free: function (params) {
                                dispatch(A.silentFreeUpdateAction(__assign(__assign({}, params), { def: def })));
                                dispatch(A.refreshFreeAction(__assign(__assign({}, params), { initiator: initiator, def: def })));
                            },
                            task: function (params) {
                                dispatch(A.silentUpdateAction(__assign(__assign({}, params), { def: def })));
                                dispatch(A.refreshAction(__assign(__assign({}, params), { initiator: initiator, def: def })));
                            },
                        });
                    });
                    return;
                }
                case XbpmActionType.ADD_BLOCK: {
                    _this.handleFormActionIfBlockValid(event.target, function () {
                        _this.matchParams({
                            free: function (params) {
                                dispatch(A.silentFreeUpdateAction(__assign(__assign({}, params), { def: def })));
                                dispatch(A.addFreeBlockAction(__assign(__assign({}, params), { initiator: initiator })));
                            },
                            task: function (params) {
                                dispatch(A.silentUpdateAction(__assign(__assign({}, params), { def: def })));
                                dispatch(A.addBlockAction(__assign(__assign({}, params), { initiator: initiator })));
                            },
                        });
                    });
                    return;
                }
                case XbpmActionType.DELETE_BLOCK: {
                    _this.matchParams({
                        free: function (params) {
                            dispatch(A.silentFreeUpdateAction(__assign(__assign({}, params), { def: def })));
                            dispatch(A.removeFreeBlockAction(__assign(__assign({}, params), { initiator: initiator })));
                        },
                        task: function (params) {
                            dispatch(A.silentUpdateAction(__assign(__assign({}, params), { def: def })));
                            dispatch(A.removeBlockAction(__assign(__assign({}, params), { initiator: initiator })));
                        },
                    });
                    return;
                }
                case XbpmActionType.OPEN_MODAL_FORM:
                    _this.matchParams({
                        task: function (params) {
                            dispatch(A.silentUpdateAction(__assign(__assign({}, params), { def: def })));
                            dispatch(A.loadModalAction(__assign(__assign({}, params), { initiator: initiator })));
                        },
                    });
                    return;
                case XbpmActionType.CLOSE_MODAL_FORM:
                    _this.handleFormActionIfBlockValid(event.target, function () {
                        return _this.matchParams({
                            task: function (params) { return dispatch(A.closeModalAction(__assign(__assign({}, params), { initiator: initiator, def: def }))); },
                        });
                    });
                    return;
                case XbpmActionType.CANCEL:
                    _this.matchParams({
                        task: function (params) { return (!params.modalFormCode ? A.cancelAction() : A.cancelModalAction()); },
                        _default: function () { return A.cancelAction(); },
                    });
                    return;
                case XbpmActionType.FRONT_CLICK:
                    _this.matchParams({
                        free: function (params) {
                            dispatch(A.silentFreeUpdateAction(__assign(__assign({}, params), { def: def })));
                            console.error("BackClick isn't implemented for FreeForm!"); // TODO: impl back click for free form
                        },
                        task: function (params) {
                            dispatch(A.silentUpdateAction(__assign(__assign({}, params), { def: def })));
                            dispatch(A.clickRequestAction(__assign(__assign({}, params), { initiator: initiator })));
                        },
                    });
                    return;
                case XbpmActionType.NAVIGATE:
                    _this.matchParams({
                        free: function (params) { return dispatch(A.silentFreeUpdateAction(__assign(__assign({}, params), { def: def }))); },
                        task: function (params) { return dispatch(A.silentUpdateAction(__assign(__assign({}, params), { def: def }))); },
                    });
                    dispatch(A.navigateWithInitiatorAction({ initiator: initiator }));
                    return;
                case ExtraActionType.ERROR:
                    return dispatch(A.internalErrorAction({ error: event.data }));
                case ExtraActionType.LOADING:
                    return dispatch(A.internalLoadingAction({ loading: event.data }));
            }
        };
        _this.handleFormActionIfBlockValid = function (target, emit) { return __awaiter(_this, void 0, void 0, function () {
            var _a, context, eventsHandler, _b, validationBlockCode, isIgnoreValidation, block, canSubmit, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.props.formHandler, context = _a.context, eventsHandler = _a.eventsHandler;
                        _b = target.frontOptions, validationBlockCode = _b.validationBlockCode, isIgnoreValidation = _b.isIgnoreValidation;
                        block = validationBlockCode && context.findFormulaDefinitionBy('code', validationBlockCode);
                        _c = target.kind !== XbpmFieldType.BUTTON || !!isIgnoreValidation;
                        if (_c) return [3 /*break*/, 2];
                        return [4 /*yield*/, context.afterValidation(block)];
                    case 1:
                        _c = (_d.sent());
                        _d.label = 2;
                    case 2:
                        canSubmit = _c;
                        if (canSubmit) {
                            emit();
                        }
                        else {
                            eventsHandler.clearPending();
                            this.highlightErrors(block);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        _this.handleFormElement = function (def, fieldId, fieldValue) {
            var findEl = function (id, elements) {
                var el = elements.find(function (e) { return e.id === id; });
                if (el) {
                    el.value = fieldValue;
                    return;
                }
                elements.forEach(function (e) { return findEl(id, e.elements || []); });
            };
            findEl(fieldId, R.pathOr([], ['elements'], def));
            return def;
        };
        return _this;
    }
    Object.defineProperty(FormBaseComponent.prototype, "isBusy", {
        get: function () {
            return this.props.isLoading || this.props.isSubmitting;
        },
        enumerable: true,
        configurable: true
    });
    FormBaseComponent.prototype.onComponentMount = function (mount) {
        this.props.dispatch(A.formMountAction(mount));
    };
    FormBaseComponent.prototype.componentDidMount = function () {
        if (this.isBusy) {
            this.onBusy();
        }
        this.onComponentMount(true);
        this.loadForm();
    };
    FormBaseComponent.prototype.componentWillUnmount = function () {
        this.onComponentMount(false);
    };
    FormBaseComponent.prototype.render = function () {
        var _a = this.props, def = _a.def, formHandler = _a.formHandler;
        return formHandler.renderForm(this.handleFormActions, def);
    };
    FormBaseComponent.prototype.highlightErrors = function (element) {
        var onValidationErrorsHighlight = this.props.onValidationErrorsHighlight;
        var context = this.props.formHandler.context;
        context.highlightErrors(element);
        if (onValidationErrorsHighlight && context.errors && !R.isEmpty(context.errors)) {
            // highlight only errors within block validation, if present, or all form errors
            onValidationErrorsHighlight(context.blockValidationErrors || context.errors);
        }
    };
    return FormBaseComponent;
}(React.PureComponent));
// connect to redux store
var FormBaseConnected = connect(mapStateToProps, mapDispatchToProps)(FormBaseComponent);
// export with props type
export var FormBase = FormBaseConnected;
//# sourceMappingURL=FormBase.js.map